import React, { useEffect, useState } from "react";
import Card from "../../components/Card/Card";
import { toast } from "react-toastify";
import http from "../../http-common";
import { ButtonSet, Row } from "carbon-components-react";
import { Column } from "carbon-components-react";
import { TextInput } from "carbon-components-react";
import { useForm } from "react-hook-form";
import { Form } from "carbon-components-react";
import { Button } from "carbon-components-react";
import { useNavigate, useParams } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { yupResolver } from "@hookform/resolvers/yup";
import { internshipApplicationScoreSchema } from "../../services/SchemaService";
import SubmitButton from "../../components/Buttons/SubmitButton";
import CancelButton from "../../components/Buttons/CancelButton";

const ScoreTraineePage = () => {
  const params = useParams();
  const [id] = useState(params.id);
  const { user } = useAuth();
  const [criteria, setCriteria] = useState([]);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(internshipApplicationScoreSchema),
    mode: "onBlur",
  });

  const navigate = useNavigate();

  const getCriteria = async () => {
    try {
      const response = await http.get("/internships/evaluation-domains");
      setCriteria(response.data);
    } catch (error) {
      toast.error("Erro ao carregar mapa de pontuação");
    }
  };

  useEffect(() => {
    getCriteria();
  }, []);

  const onSubmit = async (data) => {
    try {
      data.applicationId = id;
      data.username = user.username;
      console.log(data);
      const response = await http.post("/internships/trainees/score", data);
      navigate("../candidaturas-para-estagio/");
    } catch (error) {
      toast.error(error?.response?.data.message);
    }
  };

  return (
    <Card title="Pontuar Candidato">
      <Form onSubmit={handleSubmit(onSubmit)}>
        {criteria.map((d) => (
          <div className="mt-2" key={d.domainName.code}>
            {d.criteria.map((c) => (
              <Row key={c.code}>
                <Column sm={12} md={9} lg={9}>
                  <p className="mt-1">{c.question}</p>
                </Column>
                <Column sm={12} md={3} lg={3}>
                  <TextInput
                    id={c.code}
                    labelText=""
                    placeholder=""
                    {...register(c.code)}
                  />
                  <p className="field-error">{errors[c.code]?.message}</p>
                </Column>
              </Row>
            ))}
          </div>
        ))}

        <ButtonSet className="mt-2">
          <SubmitButton />
          <CancelButton />
        </ButtonSet>
      </Form>
    </Card>
  );
};

export default ScoreTraineePage;
